import moment from "moment";
import { getRunbookStatusLabel, getRunbookActionStatusLabel, RunbookStatus, RunbookActionStatus } from "../../helpers/utils";

export const calcDurationMinutes = (start, end) => {
    if (!start || !end) return null;
    return moment(end).diff(moment(start), "minutes");
};

export const STATUS_OPTIONS = Object.values(RunbookStatus).map((value) => ({
    name: getRunbookStatusLabel(value),
    value,
}));

export const ACTION_STATUS_OPTIONS = Object.values(RunbookActionStatus).map((value) => ({
    name: getRunbookActionStatusLabel(value),
    value,
}));

export const INITIAL_FORM = {
    name: "",
    refId: "",
    description: "",
    owner: null,
    plannedStartDate: null,
    plannedEndDate: null,
    actualStartDate: null,
    actualEndDate: null,
    assignees: [],
    status: RunbookStatus.Draft,
    attachments: [],
};

export const INITIAL_ACTION_FORM = {
    title: "",
    refId: "",
    description: "",
    order: 1,
    plannedStartDate: null,
    plannedEndDate: null,
    actualStartDate: null,
    actualEndDate: null,
    status: RunbookActionStatus.Pending,
    notes: "",
    assignees: [],
    attachments: [],
};